import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { styled } from '@mui/material';
import { TextField } from '@calefy-inc/informedMaterial';
import {
  withFormStyles,
  WithFormStyles,
} from '../../../../../../util/withFormStyles';
import { useIsPolicyStreamOrganization } from '../../../../../PolicyStream/hooks/useIsPolicyStreamOrganization';
import {
  WhiteLabelSectionDivider,
  WhiteLabelSectionRoot,
} from './whiteLabelSectionCommon';

export const PolicyStreamIntroductoryTextSection = withFormStyles()(
  function PolicyStreamIntroductoryTextSection({ classes }: WithFormStyles) {
    const isPolicyStreamOrganization = useIsPolicyStreamOrganization(false);

    if (!isPolicyStreamOrganization) {
      return null;
    }

    return (
      <WhiteLabelSectionRoot>
        <Typography variant='h6' gutterBottom>
          PolicyStream Welcome
        </Typography>
        <WhiteLabelSectionDivider />

        <IntroductoryTextBlock>
          <TextField
            name='policystreamIntroductoryText'
            label='Introductory Text'
            variant='standard'
            fullWidth
            multiline
            rows={4}
            className={classes.textarea}
          />
        </IntroductoryTextBlock>
      </WhiteLabelSectionRoot>
    );
  },
);

const IntroductoryTextBlock = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));
